<template>
    <div v-if="coach">
        <button-tooltip icon :tooltip="tooltip" @click="showSetStarsDialog" buttonClass="stars-btn">
            <rating-stars :value="stars" size="16" />
        </button-tooltip>

        <set-stars-dialog :coach="coach" ref="stars" @success="onSuccess" />
    </div>
</template>

<script>

import SetStarsDialog from '@/components/student/SetStarsDialog'
import RatingStars from '@/components/common/RatingStars'
import ButtonTooltip from '@/components/common/ButtonTooltip'

import { db } from '@/utils/Firebase'
import { mapState, mapMutations } from 'vuex'

export default {
    components: {
        SetStarsDialog,
        RatingStars,
        ButtonTooltip,
    },
    computed: {
        ...mapState(['toolbarCoach']),
        coach(vm = this) {
            return vm.toolbarCoach
        },
        coachId(vm = this) {
            return vm.coach?.id || vm.$route.params.uid
        },
        stars(vm = this) {
            return vm.coach?.rating?.stars || 0
        },
        isMyCoach(vm = this) {
            return vm.account?.studentSubscription?.coachId === vm.coachId
        },
        lastRate(vm = this) {
            return vm.account?.studentSubscription?.lastRate || null
        },
        ratedThisMonth(vm = this) {
            if (!vm.lastRate) return false
            return vm.$moment(vm.lastRate).isSame(vm.$moment(), 'month')
        },
        tooltip(vm = this) {
            return vm.isMyCoach ? vm.$t('student.rate_coach') : vm.$t('coach.rating')
        },
    },
    methods: {
        ...mapMutations(['setToolbarCoach']),
        showSetStarsDialog() {
            const vm = this
            if (!vm.isMyCoach) return vm.toast(vm.$t('common.cant_rate_coach'), 'error')
            if (vm.ratedThisMonth) return vm.toast(vm.$t('common.cant_rate_coach_this_month'), 'error')
            vm.$refs.stars.show()
        },
        async onSuccess() {
            const vm = this
            const coachRef = await db.collection('users').doc(vm.coachId).get()
            if (coachRef.exists) vm.setToolbarCoach({ id: coachRef.id, ...coachRef.data() })
        }
    }
}
</script>

<style scoped>

.stars-btn {
    width: auto !important;
    min-width: 36px;
    padding: 0 8px !important;
}

</style>
